"use client";
import { useEffect } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

import styles from "./styles.module.css";

const SeoContent = ({ seoContent }) => {
  const wrapperClass = classNames({
    [styles.wrapper]: true,
  });

  let bodyContent = seoContent;
  if (seoContent?.indexOf("<body>") > 0) {
    const bodyStartIndex = seoContent?.indexOf("<body>") + "<body>".length;
    const bodyEndIndex = seoContent?.indexOf("</body>");
    bodyContent = seoContent?.substring(bodyStartIndex, bodyEndIndex);
  }

  useEffect(() => {
    const preElement = document.querySelector(".language-markup");
    if (preElement) {
      const codeContent = preElement.innerHTML;
      const cleanedContent = codeContent.replace(/<code>/g, "").replace(/<\/code>/g, "");
      preElement.outerHTML = cleanedContent;
    }
  }, []);

  const decodeHTMLEntities = (text) => {
    const entities = {
      "&uuml;": "ü",
      "&Uuml;": "Ü",
      "&ccedil;": "ç",
      "&Ccedil;": "Ç",
      "&ouml;": "ö",
      "&Ouml;": "Ö",
      "&ugrave;": "u",
      "&Ugrave;": "U",
      "&shy;": "",
      "&rsquo;": "’",
      "&lsquo;": "‘",
      "&nbsp;": " ",
      "&gt;": ">",
      "&lt;": "<",
    };

    Object.keys(entities).forEach((entity) => {
      text = text?.replace(new RegExp(entity, "g"), entities[entity]);
    });
    return text;
  };

  const removeInlineStyles = (html) => {
    return html?.replace(/ style="[^"]*"/g, "");
  };

  const sanitizedContent = decodeHTMLEntities(removeInlineStyles(bodyContent));

  return (
    <>
      {seoContent && (
        <>
          <div className={wrapperClass}>
            <div className={styles.seoContent}>
              <div dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
            </div>
          </div>
        </>
      )}
    </>
  );
};

SeoContent.propTypes = {
  seoContent: PropTypes.string,
};

export default SeoContent;
